import React, {useState, useEffect} from 'react';
import ProgramSelector from '../common/ProgramSelectorComp';
import ClassSelector from '../common/ClassSelectorComp';
import ProgramAssignmentTable from './ProgramAssignmentTableComp';
import StudentAssignmentTable from './StudentAssignmentTableComp';
import ProgramModuleContainer from './moduleComp/ModuleContainer';
import StudentModuleContainer from './studentModuleComp/StudentModuleContainer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { request, deleteThis } from '../../redux/actions/genericAction';
import StaticNav from '../common/StaticNav';
import { convertDictionaryKeys, isObjectEmpty } from '../../Utils';
import {Redirect} from 'react-router-dom';
import { toArray, arrayToObject, getPretestType } from '../../Utils';
import Row from 'react-bootstrap/Row';
import { wizzardBarStyle } from '../common/theme';
import { Date } from 'core-js';

function AssignmentsPage({isAdmin, database, request, deleteThis, programs, programsByName, rawPrograms}) {
  const [hasMouseInsideModulesPanel, setHasMouseInsideModulesPanel] = useState(false);
  const [showModulesComp, setShowModulesComp] = useState('');
  const [hasDatabaseData, sethasDatabaseData] = useState(true);
  const [ownProgramsData, setOwnProgramsData] = useState({});
  const [categsData, setCategsData] = useState({});
  const [assignmentRaw, setAssignmentRaw] = useState([]);
  const [assignmentData, setAssignmentData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [processedProgramAssignments, setProcessedProgramAssignments] = useState([]);
  const [processedStudentAssignments, setProcessedStudentAssignments] = useState([]);
  const [classID, setClassID] = useState('');
  const [currentCateg, setCurrentCateg] = useState('(K-3) Reading Programs');
  const [classData, setClassData] = useState([]);
  const [resetInnerSaveState,setResetInnerSaveState]= useState(false);
  
  let categoryTypes = [
    'Recently Used Programs','Assigned Programs','Student Assignments','Favorite Programs',
    '(K-3) Reading Programs','(4-6) Reading Programs','Reader Programs',
    '(K-3) Math Programs','(4-6) Math Programs','Mad Minute',
    'ESL Programs','Science and Geography Programs','User Programs','Student Marks'
  ];

  useEffect(()=>{

    if(!categsData[currentCateg] || categsData[currentCateg].length===0){
      let newCategory = categoryTypes.find(e=>(categsData[e] && categsData[e].length>0));
      setCurrentCateg(newCategory);
    }
  });

  // loads which assignments go to which students in which programs
  // UPDATES ON - classID -&&- class assignments database -&&- students for current class database -&&- a list of programs in a category
  const tryLoadingAssignmentsNow = () => {
    if(classID=='') return;
    if(isObjectEmpty(ownProgramsData)) return;
    if(!database['getAllClassAssignments'] || !database['getAllClassAssignments'].isLoaded) return;
    if(!database['getStudentsForClass'] || !database['getStudentsForClass'].isLoaded) return;
    if(isObjectEmpty(categsData)) return;

    // add program favorites to program group list
    let currentClass = classData.filter(e=>e.ClassID === classID)[0];
    let categories = {...categsData};
    let ownedPrograms = arrayToObject(toArray(database['getAllPrograms'].data),'NAME');

    if(currentClass.Favorites !=='' && categsData['Favorite Programs'].length === 0){
      let favPrograms = (currentClass.Favorites)?currentClass.Favorites
        .split(',')
        .map(e=>programs[e])
        .filter((progRec)=> progRec.id in ownedPrograms):[];

      categories['Favorite Programs'] = favPrograms;
    }

    // add recently used programs to group list
    let assignedPrograms = toArray(database['getAllClassAssignments'].data)
                        .filter(assRec=> (toArray(database['getStudentsForClass'].data).find(studRec=>assRec.StudentID===studRec.StudentID))?true:false ) // make sure the assigned students are still in this class (not deleted or moved)
                        .map(e=>programsByName[e.ProgramID])
                        .filter(e=>e) // is a valid record
                        .reduce((acc,e)=>{ // remove duplicates
                          acc[e.id] = e;
                          return acc;
                        },{});
    categories['Assigned Programs'] = toArray(assignedPrograms).sort((a,b) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : (a.title.toUpperCase() < b.title.toUpperCase() ? -1 : 0));

    // create an array of programs that have students for each program that has assignments for each student
    if(currentCateg !=='Student Assignments'){
      let processedPrograms = categsData[currentCateg].map((progRec, i)=> {
          let combined = {hasPretest:'Unprocessed', hasPosttest:'Unprocessed', hasAssignment: 'Unprocessed'};
          let students = [...studentData].map(studRec=>{
            let assignmentID = `${studRec.StudentID}+${progRec.title}`;
            if(progRec.subcateg === 'User Programs'){
              assignmentID = `${studRec.StudentID}+${progRec.id}`;
              assignmentID = assignmentID.replace('LESSON~','LESSON-');
              assignmentID = assignmentID.replace('QUIZ~','QUIZ-');
              assignmentID = assignmentID.replace('COURSE~','COURSE-');
            }

            let assignment = (assignmentRaw.data[assignmentID]) ? assignmentRaw.data[assignmentID].XmlControl : '';    
            combined.hasPretest = (assignment.startsWith('Y|'))?(combined.hasPretest==='None' || combined.hasPretest==='Mixed' )?'Mixed': 'All' : (combined.hasPretest==='All' || combined.hasPretest==='Mixed' )?'Mixed':'None';
            combined.hasAssignment = (assignment.startsWith('N'))?(combined.hasAssignment==='None' || combined.hasAssignment==='Mixed' )?'Mixed': 'All' : (combined.hasAssignment==='All' || combined.hasAssignment==='Mixed' )?'Mixed':'None';
            combined.hasPosttest = (assignment.startsWith('Y_'))?(combined.hasPosttest==='None' || combined.hasPosttest==='Mixed' )?'Mixed': 'All' : (combined.hasPosttest==='All' || combined.hasPosttest==='Mixed' )?'Mixed':'None';

            let assignedModules = (assignment) ? assignment.split('|')[2].split(';') : [];

            let author='';
            if(assignmentRaw.data[assignmentID] && assignmentRaw.data[assignmentID].Author){              
              author=assignmentRaw.data[assignmentID].Author;
              combined.assignAuthor = author;
            }
          
            return {...studRec, assignAuthor:author, hasPretest:assignment.startsWith('Y|'), hasPosttest: assignment.startsWith('Y_'), hasAssignment: assignment.startsWith('N'), assignedModules};
//            return {...studRec, hasPretest:assignment.startsWith('Y|'), hasPosttest: assignment.startsWith('Y_'), hasAssignment: assignment.startsWith('N'), assignedModules};
          });
        return {...progRec, students, ...combined };
      });
      setProcessedProgramAssignments(processedPrograms);
      setResetInnerSaveState(true);
    }
    if(currentCateg ==='Student Assignments'){
      let processedStudents = [...studentData].map(studRec=>{
        let combined = {hasPretest:'Unprocessed', hasPosttest:'Unprocessed', hasAssignment: 'Unprocessed'};

        let programs = categsData[currentCateg].filter(progRec=>progRec.subcateg != 'User Programs').map((progRec, i)=> {
          let assignmentID = `${studRec.StudentID}+${progRec.title}`;
          if(progRec.subcateg === 'User Programs'){
            assignmentID = `${studRec.StudentID}+${progRec.id}`;
            assignmentID = assignmentID.replace('LESSON~','LESSON-');
            assignmentID = assignmentID.replace('QUIZ~','QUIZ-');
            assignmentID = assignmentID.replace('COURSE~','COURSE-');
          }
          
          let assignment = (assignmentRaw.data[assignmentID]) ? assignmentRaw.data[assignmentID].XmlControl : '';    
          combined.hasPretest = (assignment.startsWith('Y|'))?(combined.hasPretest==='None' || combined.hasPretest==='Mixed' )?'Mixed': 'All' : (combined.hasPretest==='All' || combined.hasPretest==='Mixed' )?'Mixed':'None';
          combined.hasAssignment = (assignment.startsWith('N'))?(combined.hasAssignment==='None' || combined.hasAssignment==='Mixed' )?'Mixed': 'All' : (combined.hasAssignment==='All' || combined.hasAssignment==='Mixed' )?'Mixed':'None';
          combined.hasPosttest = (assignment.startsWith('Y_'))?(combined.hasPosttest==='None' || combined.hasPosttest==='Mixed' )?'Mixed': 'All' : (combined.hasPosttest==='All' || combined.hasPosttest==='Mixed' )?'Mixed':'None';

          let assignedModules = (assignment) ? assignment.split('|')[2].split(';') : [];
          
          let author='';
          if(assignmentRaw.data[assignmentID] && assignmentRaw.data[assignmentID].Author){              
            author=assignmentRaw.data[assignmentID].Author;
            combined.assignAuthor = author;
          }

          return {...progRec, assignAuthor:author, hasPretest:assignment.startsWith('Y|'), hasPosttest: assignment.startsWith('Y_'), hasAssignment: assignment.startsWith('N'), assignedModules};
        });
        return {...studRec, programs, ...combined };
      });
      setProcessedStudentAssignments(processedStudents);
      setResetInnerSaveState(true);
    }
    // if either favorite programs or recently used has changes then reset categories
    if(JSON.stringify(categories['Favorite Programs'])!==JSON.stringify(categsData['Favorite Programs']) || 
      JSON.stringify(categories['Assigned Programs'])!==JSON.stringify(categsData['Assigned Programs']) ||
      JSON.stringify(categories['Student Assignments'])!==JSON.stringify(categsData['Student Assignments'])
      ){
      setCategsData(categories);
      return;
    }
  }; 

  // don't process the assignments without a classID, class assignments database, students for current class database and a list of programs in a category
  useEffect(() =>{tryLoadingAssignmentsNow();},[assignmentRaw]);
  useEffect(() =>{tryLoadingAssignmentsNow();},[studentData]);
  useEffect(() =>{tryLoadingAssignmentsNow();},[categsData]);
  useEffect(()=> {tryLoadingAssignmentsNow();},[currentCateg]);
  useEffect(()=> {
    let categories = {...categsData}; 
    categories['Favorite Programs']=[]; // reset the favorites when the admin changes the class
    setCategsData(categories);
    tryLoadingAssignmentsNow();
  },[classID]);
  useEffect(()=> {tryLoadingAssignmentsNow();},[ownProgramsData]);
  
  // builds a list of program categories based on the programs the schools own
  // UPDATES - only one time when programs owned database returns
  const buildProgramCategories=()=>{
    // wait for the programs database to return with the programs they own
    if(!isObjectEmpty(ownProgramsData)) return; 
    setOwnProgramsData(database['getAllPrograms'].data);

    let programs = toArray(pageState.programs);
    let ownedPrograms = arrayToObject(toArray(database['getAllPrograms'].data),'NAME');

    // don't include the Favorite and assigned programs when recreating the student assignments
    let cachedFavs = (categsData['Favorite Programs'])?categsData['Favorite Programs']:[];
    let cachedAssignments = (categsData['Assigned Programs'])?categsData['Assigned Programs']:[];
    let categories = {
      '(K-3) Reading Programs': programs.filter((progRec)=>progRec.subcateg==='(K-3) Reading Programs' && progRec.id in ownedPrograms),
      '(4-6) Reading Programs': programs.filter((progRec)=>progRec.subcateg==='(4-6) Reading Programs' && progRec.id in ownedPrograms),
      '(K-3) Math Programs': programs.filter((progRec)=>progRec.subcateg==='(K-3) Math Programs' && progRec.id in ownedPrograms),
      '(4-6) Math Programs': programs.filter((progRec)=>progRec.subcateg==='(4-6) Math Programs' && progRec.id in ownedPrograms),
      'Science and Geography Programs': programs.filter((progRec)=>progRec.subcateg==='Science and Geography Programs' && progRec.id in ownedPrograms),
      'User Programs': programs.filter((progRec)=>progRec.categ==='User' && progRec.id in ownedPrograms),
      'ESL Programs': programs.filter((progRec)=>progRec.subcateg==='ELL Programs' && progRec.id in ownedPrograms),
      'Reader Programs': programs.filter((progRec)=>progRec.subcateg==='Reader Programs' && progRec.id in ownedPrograms),
//      'Mad Minute': [],
      'Mad Minute': programs.filter((progRec)=>progRec.subcateg==='Mad Minute' && progRec.id in ownedPrograms),
      'Favorite Programs': [],
      'Assigned Programs': [],
      'Student Assignments':[]
    };
    // console.log(sessionStorage.getItem('productionPath'));
    // Add User Content as programs/Quizes
    if(database['getAllUserPrograms'] && database['getAllUserPrograms'].isLoaded && sessionStorage.getItem('productionPath')!=='0000000000000000'){
      categories['User Programs'] = Object.keys(database['getAllUserPrograms'].data).map((key,i)=>{
        const e = database['getAllUserPrograms'].data[key];  

        let stringDate = (new Date(Number(e['LastUpdated']))).toLocaleString().split(',')[0];
        let author = 'Removed Teacher';
        if(database['getAllClasses'] && database['getAllClasses'].data[e['TeacherID']])
          author = database['getAllClasses'].data[e['TeacherID']].Classname;
        if(database['getCustomer'] && database['getCustomer'].data.ID===e['TeacherID'])
          author = 'Shared';

        return { 
          schoolID:e['SchoolID'],
          id: e['progID'].toUpperCase()+'-'+e['ContentID'],
          categ: 'User',
          gradeTitle: e['Title'],
          title: stringDate+' - '+author+' - '+e['Title'],
          shortTitle: e['ShortTitle'],
          modules:[[e['progID'].toUpperCase(),e['Description']]],
          order: i,
          suborder:3,
          subcateg: 'User Programs',
          authorID: e['TeacherID'],
          standard:e['Standard'],
          version:e['Version'],
          LastUpdated:e['LastUpdated'],
          Description:e['Description'],
          tags:e['Tags']
        };
      }).filter(item=> (item.title.indexOf('Removed Teacher'))===-1)
        .filter(item=> (isAdmin || item.authorID==classID || item.authorID==database['getCustomer'].data['ID']))
        .sort((b,a) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : (a.title.toUpperCase() < b.title.toUpperCase() ? -1 : 0));
    }

    //categories['Student Assignments'] = toArray(categories).reduce((acc,e)=>{return [...acc, ...e];},[]);
    // categories['Student Assignments'] = programs.filter((progRec)=>progRec.id in ownedPrograms).sort((a,b) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : (a.title.toUpperCase() < b.title.toUpperCase() ? -1 : 0));//toArray(categories).reduce((acc,e)=>{return [...acc, ...e];},[]);
    categories['Student Assignments'] = [...programs];//toArray(categories).reduce((acc,e)=>{return [...acc, ...e];},[]);

    categories['Favorite Programs'] = cachedFavs;
    categories['Assigned Programs'] = cachedAssignments;

    setCategsData(categories);
  };

  // read the assignments and students for the current class from the database
  // UPDATES - when getAllClassAssignments DOESN'T have a value
  const fetchAssignmentData=()=>{

    if(!database['getAllClassAssignments']){

      if(classID=='') return;
      let getStudentsForClassQuery={
        params: classID,
        func:'getStudentsForClass'            
      };

      let getAllClassAssignmentsQuery={
        params: classID,
        func:'getAllClassAssignments',
        nextRequest: getStudentsForClassQuery           
      };
      request(getAllClassAssignmentsQuery);     
      setOwnProgramsData({});  
    }
  };

  useEffect(() => {
    // if there is no security tag then log them out
    if(!database['getCustomer'])
      return sethasDatabaseData(false);

    buildProgramCategories();
    fetchAssignmentData();
  });

  // converts database['getAllClassAssignments'] to setAssignmentRaw and thus triggers tryLoadingAssignmentsNow
  // UPDATES - when database['getAllClassAssignments'] has changed
  useEffect(() => {
    if(database['getAllClassAssignments'] && database['getAllClassAssignments'].isLoaded){   
      setAssignmentRaw({...database['getAllClassAssignments']});
    }
  }, [database['getAllClassAssignments']]);   
  
  // converts database['getStudentsForClass'] to setStudentData and thus triggers tryLoadingAssignmentsNow
  // UPDATES - when database['getStudentsForClass'] has changed  
  useEffect(() => {
    if(database['getStudentsForClass'] && database['getStudentsForClass'].isLoaded){
      let students = {...database['getStudentsForClass']};
      students = toArray(database['getStudentsForClass'].data)
       .sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() === b.Name.toUpperCase() ? -1 : 0));  
       setStudentData(students);
    }   
  }, [database['getStudentsForClass']]);    

  // converts database['getAllClasses'] to setClassData and setClassID, thus triggers tryLoadingAssignmentsNow
  // UPDATES - when database['getAllClasses'] has changed -&&- there is no classID 
  useEffect(() => {

    if(!classID){ // don't load the classes after they have already been loaded
      deleteThis('getAllClassAssignments'); // reload the assignments incase there was interference with another page...
      let classes = {...database['getAllClasses']};
      if(database['getAllClasses'] && database['getAllClasses'].isLoaded){
        classes = toArray(database['getAllClasses'].data)
        .sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() < b.Classname.toUpperCase() ? -1 : 0))
        .map(e=>{e.isSelected=false;return e;});
      }    
      setClassData(classes);
      if(classes.length>0){
        if(isAdmin)
          setClassID(classes[0].ClassID);
        else
          setClassID(sessionStorage.getItem('userID'));
        classes[0].isSelected = true;
      }
    }
  }, [database['getAllClasses']]);   
  
  // if the security token is not valid then redirect them to the login screen
  if (!hasDatabaseData) {
    return <Redirect to='/' />;
  }

  const pageState = {
    hasDatabaseData, sethasDatabaseData,
    isAdmin, database, request, programs,
    ownProgramsData, setOwnProgramsData,
    assignmentData, setAssignmentData,
    processedProgramAssignments, setProcessedProgramAssignments,
    processedStudentAssignments, setProcessedStudentAssignments,
    showModulesComp, setShowModulesComp,
    request, deleteThis, rawPrograms,
    classID, setClassID,
    resetInnerSaveState,setResetInnerSaveState,
    hasMouseInsideModulesPanel, setHasMouseInsideModulesPanel
    // saveAssignments, checkboxState, setCheckboxState,
    // isSaving, setIsSaving
  };

  return (    
    (!classID)?<>Please add some classes</>:
    <div>
      <br/>
      <StaticNav currentTopic={'Assignments'}/> 
      
      { (showModulesComp==='') && <>
        {isAdmin && <Row style={wizzardBarStyle}> <h5>  &nbsp; 1) Select Your Class </h5></Row>}
        {isAdmin && <><ClassSelector pageState={{deleteThis, classID, setClassID, classes:classData}}/></>}
        <ProgramSelector pageState={{currentCateg, setCurrentCateg, categsData}} isAdmin={isAdmin} isAssignments='true'/> <br/>
        {(currentCateg ==='Student Assignments') && <><Row style={wizzardBarStyle}> <h5>  &nbsp; {isAdmin?3:2}) Edit Program Assignments by Student </h5></Row><br/></>}
        {(currentCateg !=='Student Assignments') && <><Row style={wizzardBarStyle}> <h5>  &nbsp; {isAdmin?3:2}) Edit Student Assignments by Program </h5></Row><br/></>}
        {(currentCateg !=='Student Assignments') && <ProgramAssignmentTable pageState={pageState}/>}
        {(currentCateg ==='Student Assignments') && <StudentAssignmentTable pageState={pageState}/>}
        
      </>}

      {(currentCateg !=='Student Assignments') && <ProgramModuleContainer pageState={pageState}/>}
      {(currentCateg ==='Student Assignments') && <StudentModuleContainer pageState={pageState}/>}
    </div>
  );
}

AssignmentsPage.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  return {
      isAdmin: (state.dashboardReducer.login === 'Admin'),
      database: state.genericReducer,
      rawPrograms: state.rawProgramReducer,
      programs: convertDictionaryKeys(state.rawProgramReducer.programs, 'id'), 
      programsByName: convertDictionaryKeys(state.rawProgramReducer.programs, 'title')      
 };
};

export default connect(mapStateToProps, {request, deleteThis})(AssignmentsPage);
